import {
  WITHDRAW_MONEY_DECLINED,
  WITHDRAW_MONEY_OVERDUE,
  WITHDRAW_MONEY_INSUFFICIENT_AMOUNT,
  WITHDRAW_MONEY_FAILED,
  WITHDRAW_MONEY_INVALID_REQUEST,
  WITHDRAW_MONEY_SUCCESS,
  WITHDRAW_MONEY_LIMITNOTSET,
  WITHDRAW_OPERATION_NOT_PERMITTED,
  WITHDRAW_NOT_SUFFICIENT_LIMIT,
  WITHDRAW_TRANSACTION_LIMIT_EXCEEDED,
  RESET_WITHDRAW_MONEY,
  LOADING_WITHDRAW,
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  invalidRequest: false,
  limitNotSet: false,
  declined: false,
  overdue: false,
  insufficientAmount: false,
  data: {},
  operationNotPermitted: false,
  notSufficientLimit: false,
  transactionLimitExceeded: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_WITHDRAW:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        invalidRequest: false,
        declined: false,
        overdue: false,
        operationNotPermitted: false,
        insufficientAmount: false,
        limitNotSet: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        data: {}
      };

    case WITHDRAW_MONEY_DECLINED:
      return {
        ...state,
        isLoading: false,
        declined: true,
        success: false,
        invalidRequest: false,
        failed: false,
        insufficientAmount: false,
        limitNotSet: false,
        overdue: false,
        data: action.payload,
        operationNotPermitted: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
      };

    case WITHDRAW_MONEY_OVERDUE:
      return {
        ...state,
        isLoading: false,
        declined: false,
        success: false,
        invalidRequest: false,
        failed: false,
        insufficientAmount: false,
        limitNotSet: false,
        operationNotPermitted: false,
        overdue: true,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        data: action.payload
      };

    case WITHDRAW_MONEY_INSUFFICIENT_AMOUNT:
      return {
        ...state,
        isLoading: false,
        declined: false,
        success: false,
        invalidRequest: false,
        failed: false,
        insufficientAmount: true,
        limitNotSet: false,
        operationNotPermitted: false,
        overdue: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        data: action.payload
      };

    case WITHDRAW_MONEY_FAILED:
      return {
        ...state,
        isLoading: false,
        declined: false,
        success: false,
        invalidRequest: false,
        failed: true,
        insufficientAmount: false,
        limitNotSet: false,
        operationNotPermitted: false,
        overdue: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        data: action.payload
      };

    case WITHDRAW_MONEY_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        declined: false,
        success: false,
        invalidRequest: true,
        failed: false,
        insufficientAmount: false,
        limitNotSet: false,
        overdue: false,
        data: action.payload,
        operationNotPermitted: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
      };

    case WITHDRAW_MONEY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        declined: false,
        success: true,
        invalidRequest: false,
        failed: false,
        insufficientAmount: false,
        limitNotSet: false,
        overdue: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        data: action.payload
      };

    case WITHDRAW_MONEY_LIMITNOTSET:
      return {
        ...state,
        isLoading: false,
        declined: false,
        success: false,
        invalidRequest: false,
        failed: false,
        insufficientAmount: false,
        limitNotSet: true,
        overdue: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        data: action.payload
      };

    case WITHDRAW_OPERATION_NOT_PERMITTED:
      return {
        ...state,
        isLoading: false,
        declined: false,
        success: false,
        invalidRequest: false,
        failed: false,
        insufficientAmount: false,
        limitNotSet: false,
        operationNotPermitted: true,
        overdue: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        data: action.payload
      };

    case WITHDRAW_NOT_SUFFICIENT_LIMIT:
      return {
        ...state,
        isLoading: false,
        declined: false,
        success: false,
        invalidRequest: false,
        failed: false,
        insufficientAmount: false,
        limitNotSet: false,
        operationNotPermitted: false,
        overdue: false,
        notSufficientLimit: true,
        transactionLimitExceeded: false,
        data: action.payload
      };

    case WITHDRAW_TRANSACTION_LIMIT_EXCEEDED:
      return {
        ...state,
        isLoading: false,
        declined: false,
        success: false,
        invalidRequest: false,
        failed: false,
        insufficientAmount: false,
        limitNotSet: false,
        operationNotPermitted: false,
        overdue: false,
        notSufficientLimit: false,
        transactionLimitExceeded: true,
        data: action.payload
      };

    case RESET_WITHDRAW_MONEY:
      return (state = initialState);

    default:
      return state;
  }
};
